// src/routes/publicRoutes.js
import React, { useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import HomePage from "../pages/home";
import Agreement from "../pages/agreement";
import ThankYouPage from "../pages/thank_you";
import LoginPage from "../pages/LoginPage";
import TemplatesPage from "../pages/TemplatesPage";
import ForgotPasswordPage from "../pages/ForgotPasswordPage";
import ResetPasswordPage from "../pages/ResetPasswordPage";
import CreateTemplatesPage from "../pages/CreateTemplatesPage";
import AddFieldsInDcument from "../pages/SendTemplatePage";
import Sidebar from "../components/Sidebar";
import Content from "../components/Content";
import SendTemplateManualPage from "../pages/SendTemplateManualPage";
import SignedDocumentsPage from "../pages/SignedDocumentsPage";
import EditTemplatesPage from "../pages/EditTemplatesPage";
import PrivateRoute from "../components/PrivateRoute";
import CopyTemplatesPage from "../pages/CopyTemplatesPage";
import TemplateSignPage from "../pages/templateSign";
import OperatorSign from "../pages/operatorSign";
import SignAll from "../pages/signAll";
import CpDocumentDraftsPage from "../pages/CpDocumentDraftsPage";
import CpDocumentSignPage from "../pages/CpDocumentSignPage";
import CpDocumentsSignAllPage from "../pages/CpDocumentsSignAllPage";


const AppContent = ({ isSidebarCollapsed, handleCollapseChange }) => {
  const location = useLocation();

  const includedRoutes = [
    "/",
    "/signed-documents",
    // "/signed-documents",
    // "/prepare-template",
    // "/template/:id",
    // "/send-template",
    // "/send",
  ];

  const shouldShowSidebar = includedRoutes.some((route) => {
    if (route === location.pathname) {
      return true;
    }

    if (
      route.includes(":") &&
      location.pathname.startsWith(route.split(":")[0])
    ) {
      return true;
    }

    return false;
  });

  const sidebarWidthClass = shouldShowSidebar
    ? isSidebarCollapsed
      ? "ml-16 "
      : "ml-56"
    : "";

  return (
    <div className="flex bg-gray-50">
      {shouldShowSidebar && <Sidebar onCollapseChange={handleCollapseChange} />}

      <Content
        isSidebarCollapsed={isSidebarCollapsed}
        marginClass={sidebarWidthClass}
      >
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />

          <Route
            path="/"
            element={
              <PrivateRoute>
                <TemplatesPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/signed-documents"
            element={
              <PrivateRoute>
                <SignedDocumentsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/cp-document-drafts"
            element={<PrivateRoute><CpDocumentDraftsPage /></PrivateRoute>}
          />
          <Route
            path="/cp-document-drafts/:id"
            element={<PrivateRoute><CpDocumentDraftsPage /></PrivateRoute>}
          />
          <Route
            path="/prepare-template"
            element={
              <PrivateRoute>
                <CreateTemplatesPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/copy-template"
            element={
              <PrivateRoute>
                <CopyTemplatesPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/template/:id"
            element={
              <PrivateRoute>
                <CreateTemplatesPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/send-template"
            element={
              <PrivateRoute>
                <AddFieldsInDcument />
              </PrivateRoute>
            }
          />
          <Route
            path="/send-template/:id"
            element={
              <PrivateRoute>
                <AddFieldsInDcument />
              </PrivateRoute>
            }
          />
          <Route
            path="/send"
            element={
              <PrivateRoute>
                <SendTemplateManualPage />
              </PrivateRoute>
            }
          />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/:signSecretId" element={<HomePage />} />
          <Route path="/cp-document-sign/:signSecretId" element={<CpDocumentSignPage />} />
          <Route path="/cp-documents-sign-all" element={<CpDocumentsSignAllPage />} />
          <Route
            path="/operator-sign/:signSecretId"
            element={<OperatorSign />}
          />
          <Route
            path="/collab-phys-sign/complete"
            element={
              <div style={{ padding: 40, textAlign: "center" }}>
                Your Supervisory Agreement has been signed. You may close this
                page.
              </div>
            }
          />
          <Route
            path="/collab-phys-sign/:signSecretId"
            element={<OperatorSign mode="collabPhys" />}
          />
          <Route
            path="/collab-operator-sign/:signSecretId"
            element={<OperatorSign mode="collabOperator" />}
          />
          <Route
            path="/collab-phys-sign-all"
            element={<SignAll mode="collabPhys" />}
          />
          <Route
            path="/collab-operator-sign-all"
            element={<SignAll mode="collabOperator" />}
          />
          <Route
            path="/sign/:signSecretId/:signerId"
            element={<TemplateSignPage />}
          />
          <Route path="/collab-charts/:chartId" element={<HomePage />} />
          <Route
            path="/electronic_record_and_signature_disclosure"
            element={<Agreement />}
          />
        </Routes>
      </Content>
    </div>
  );
};

const AppRoutes = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);

  const handleCollapseChange = (collapsed) => {
    setIsSidebarCollapsed(collapsed);
  };

  return (
    <BrowserRouter>
      <AppContent
        isSidebarCollapsed={isSidebarCollapsed}
        handleCollapseChange={handleCollapseChange}
      />
    </BrowserRouter>
  );
};

export default AppRoutes;
